import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/organizations'

export default class EdgesControllerServiceOrganization {
    static async getAll() {
        return axios.get(`${detailControllerRestUrl}/edges?reserve=${true}`);
    }

    static async save(data) {
        return await axios.post(`${detailControllerRestUrl}/edges`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async applyToSide(detailId, sides, orderEdgeId) {
        return await axios.post(`${detailControllerRestUrl}/edges/sides?detailId=${detailId}?sides=${sides}?orderEdgeId=${orderEdgeId}`, JSON.stringify({}), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(edgeId) {
        return await axios.delete(`${detailControllerRestUrl}/edges/${edgeId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(edgeId, data) {
        return await axios.put(`${detailControllerRestUrl}/edges/${edgeId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
